import { render, staticRenderFns } from "./SecondaryBtn.vue?vue&type=template&id=fe0b890a&scoped=true"
import script from "./SecondaryBtn.vue?vue&type=script&lang=js"
export * from "./SecondaryBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe0b890a",
  null
  
)

export default component.exports